export interface SelectedOptions {
  layoutType: {
    name: string;
    id: number;
  };
  componentType: {
    name: string;
    id: number;
  };
  sectionSize: {
    width: number;
    height: number;
    name: string;
    id: number;
  };
  ownerOperatorPermission: boolean;
  componentName: string | null;
  expiryDate: string | null;
  startDate: string | null;
}

export enum CreateComponentStepEnums {
  SELECT_LAYOUT_TYPE = 0,
  SELECT_COMPONENT_TYPE = 1,
  SELECT_SIZE = 2,
  SELECT_OWNER_OPERATOR = 3,
  FINAL_SETTING = 4,
}
